import type { AuthConfig } from '@tmapy/beetlejuice-utils';

import { SUCCESS_ALERT_VISIBLE, SET_CONFIG_TO_STORE } from '../constants';
import type { DmxConfig } from '../types';

import type { AppActionTypes } from './actions';

type AppState = {
  config: DmxConfig & { auth?: AuthConfig; server: string };
  submitSuccessAlertVisible: boolean;
  deleteSuccessAlertVisible: boolean;
  services: { suggestAddress: string; suggestParcel: string };
};

const defaultState: AppState = {
  config: {
    version: 7,
    lang: 'cs',
    customerType: 'dtm',
    server: '',
    auth: undefined,
    editorTI: {},
    editorDI: {},
    editorZPS: {},
    reviewer: {},
  },
  // TODO Prevest do reduceru Login stranky
  submitSuccessAlertVisible: false,
  deleteSuccessAlertVisible: false,
  services: {
    suggestAddress:
      'https://services7.tmapserver.cz/ArcGIS/rest/services/Locators/cz_adr,cz_ul,cz_ob/GeocodeServer/findAddressCandidates?f=pjson&outFields=extra&extraFieldType=object',
    suggestParcel:
      'https://services7.tmapserver.cz/ArcGIS/rest/services/Locators/cz_ul,cz_par/GeocodeServer/findAddressCandidates?f=pjson&outFields=extra&extraFieldType=object',
  },
};

export const app = (state = defaultState, action: AppActionTypes): AppState => {
  switch (action.type) {
    case SET_CONFIG_TO_STORE:
      return {
        ...state,
        config: { ...action.config },
      };
    case SUCCESS_ALERT_VISIBLE.SUBMIT:
      return {
        ...state,
        submitSuccessAlertVisible: action.value,
      };
    case SUCCESS_ALERT_VISIBLE.DELETE:
      return {
        ...state,
        deleteSuccessAlertVisible: action.value,
      };
    default:
      return state;
  }
};
